import { Item, toggleStatus } from '../features/TodoSlice'

import {BsPencil} from 'react-icons/bs'
import {IoMdCheckmarkCircle} from 'react-icons/io'
import {VscServerProcess} from 'react-icons/vsc'

import { useDispatch } from 'react-redux'
import { manageDeatilsPopup, manageUpdatePopup } from '../features/ControlSlice'
import EditTodo from './controls/EditTodo'
import TaskDetails from './controls/TaskDetails'
import Deadline from './Deadline'

const TodoItem = ({id, title, description, deadline, status} : Item) => {
  const dispatch = useDispatch()

  return (
    <div className='todo_item' >
      <div className='d-flex jcsb aic' style={{paddingBottom: 10}}>
        <h4 className='todo_item__title' onClick={() => dispatch(manageDeatilsPopup(id))}>{title}</h4>
        <div>
          <BsPencil className='icon_button secondary' onClick={() => dispatch(manageUpdatePopup(id))} title="Edit Task"/>
          {
            status === 'new' ? 
            <VscServerProcess 
              className='icon_button primary' 
              onClick={() => dispatch(toggleStatus({id, status: 'in process'}))}  
              title="Start task"
            />
            : status === 'in process' ? 
            <IoMdCheckmarkCircle 
              className='icon_button primary' 
              onClick={() => dispatch(toggleStatus({id, status: 'done'}))}
              title="Mark as done"
            /> : ''
          }
        </div>
      </div>
      <Deadline deadline={deadline}/>
      
      <EditTodo id={id}/> 
      <TaskDetails id={id}/>
    </div>
  )
}

export default TodoItem